import { createContext, useContext, useState, useEffect } from "react";
import API, { clearAuthSession, setCsrfToken } from "../utils/API";

const loginContextDefaultValues = {
  google_email: "",
  google_id: "",
  loginData: {},
  sessionStatus: "checking",
  storeLoginData: () => {},
};

const LoginContext = createContext(loginContextDefaultValues);

export function LoginProvider({ children, googleProfile }) {
  const [loginData, setLoginData] = useState([]);
  const [sessionStatus, setSessionStatus] = useState("checking");

  useEffect(() => {
    API.get("auth/session")
      .then((res) => {
        const data = res?.data;
        if (data?.login_data && (data?.status === "success" || !data?.status)) {
          setCsrfToken(data.csrf_token);
          setLoginData(data.login_data);
          setSessionStatus("authenticated");
          return;
        }
        clearAuthSession();
        setSessionStatus("unauthenticated");
      })
      .catch(() => {
        clearAuthSession();
        setSessionStatus("unauthenticated");
      });
  }, []);

  useEffect(() => {
    const loginParams = googleProfile?.loginCode
      ? { login_code: googleProfile.loginCode }
      : googleProfile?.idToken
        ? { id_token: googleProfile.idToken }
        : null;

    if (loginParams) {
      const mainFunc = async () =>
        await API.post("google_login", {
          params: loginParams,
        });
      mainFunc()
        .then((res) => {
          const data = res?.data;
          if (data?.login_data && (data?.status === "success" || !data?.status)) {
            setCsrfToken(data.csrf_token);
            setLoginData(data.login_data);
            setSessionStatus("authenticated");
            if (window.location.pathname === "/tourplan/") {
              window.location.replace("/tourplan/copy_rates.php");
            }
          } else {
            clearAuthSession();
            setSessionStatus("unauthenticated");
            setLoginData({
              err: 1,
              err_msg: `Failes : ` + data?.err_msg ?? "",
            });
          }
        })
        .catch((err) => {
          console.log(`Failes : ${err}`);
          clearAuthSession();
          setSessionStatus("unauthenticated");
          setLoginData({ err: 1 });
        });
    }
  }, [googleProfile?.loginCode, googleProfile?.idToken]);

  const storeLoginData = (data) => {
    setLoginData(data);
  };

  const value = {
    google_email: googleProfile?.email,
    google_id: googleProfile?.googleId,
    loginData: loginData,
    sessionStatus,
    storeLoginData: storeLoginData,
  };

  return (
    <LoginContext.Provider value={value}>{children}</LoginContext.Provider>
  );
}

export const useLogin = () => useContext(LoginContext);
